export default "__VITE_ASSET__CxUh2jJV__"